/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import './Salary.css';
import CurrentSalaryController from '../../../domain/myProfile/salary/CurrentSalary/CurrentSalaryController';
import GovtTaxController from '../../../domain/myProfile/salary/GovtTax/GovtTaxController';
import SalaryHistoryController from '../../../domain/myProfile/salary/SalaryHistory/SalaryHistoryController';
import PayHistoryController from '../../../domain/myProfile/salary/PayHistory/PayHistoryController';
import { useAppSelector } from '../../../infra/hooks';
import AnimatedPage from '../../../common/AnimatedPage/AnimatedPage';

interface empDetailProps {
  trans: any;
  i18n?: any;
}

const SalaryPresenter: React.FC<empDetailProps> = ({ trans, i18n }) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        marginTop: isHRView ? '' : '4em',
        width: '100vw',
        paddingRight: '8em',
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: '#F5F5FA',
          width: '100%',
          padding: '1.75em',
          marginLeft:
            isHRView && i18n.language == 'en'
              ? '11em'
              : !isHRView && i18n.language == 'en'
                ? '14em'
                : '',
          marginRight: i18n.language == 'ar' ? '15em' : '',
        }}
      >
        <AnimatedPage>
          <Grid
            container
            style={{
              paddingLeft: isHRView ? '2em' : '',
            }}
          >
            <Grid
              item
              sx={{
                width: '100%',
              }}
            >
              <Grid
                container
                style={{
                  width: 'auto',
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  borderRadius: '10px',
                  opacity: '1',
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '1em',
                  paddingBottom: '1em',
                  paddingLeft: '1em',
                  paddingRight: '1em',
                }}
              >
                <Grid item xs={9}>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.header,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Salary')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                spacing={3}
                style={{
                  width: 'auto',
                  marginTop: '0.5em',
                }}
              >
                <Grid item xs={4} sm={4} md={4} lg={4}>
                  <CurrentSalaryController />
                  <Box style={{ marginTop: '1.75em' }} />
                  <GovtTaxController />
                  <Box style={{ marginTop: '1.75em' }} />
                  <SalaryHistoryController />
                </Grid>
                <Grid item xs={8} sm={8} md={8} lg={8}>
                  <PayHistoryController />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AnimatedPage>
      </Grid>
    </Grid>
  );
};

export default SalaryPresenter;
